import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";
import { router } from "./router";

Vue.use(Vuex);

interface RouterRedirect extends Vue {
    initialAction: string;
    urlBuy: string;
    urlRent: string;
    action: string;
}

const RouterRedirect = {
    props: ["initialAction", "urlBuy", "urlRent"],
    data() {
        return {
            action: this.initialAction,
        };
    },
    computed: {
        classActions() {
            return {
                "js-rent": this.isOpen && this.action === "rents",
                "js-buy": this.isOpen && this.action === "realestate",
            };
        },
    },
    mounted(this: RouterRedirect) {
        const currentRoute = router.currentRoute;

        console.log('currentRoute: ', currentRoute);
        console.log('this.initialAction: ', this.initialAction);

        if (!currentRoute.name) {
            switch (this.initialAction) {
                case "realestate":
                    this.$store.commit("resetSearch");
                    router.push(this.urlBuy + "/realestate");
                    break;
                case "rents":
                    this.$store.commit("resetSearch");
                    router.push(this.urlRent + "/rents");
                    break;
            }
        }
    },
} as ComponentOptions<RouterRedirect>;

export { RouterRedirect };



// WEBPACK FOOTER //
// ./src/components/router-redirect.ts